import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"color":"secondary","large":"","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c(VIcon,{attrs:{"left":""}},[_vm._v(" fa-light fa-xmark ")]),_vm._v(" "+_vm._s(_vm.localizer('No'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }